import { useTranslation } from 'react-i18next';

export default function PageSpinner({ fullscreen = true }) {
  const { t } = useTranslation();
  const positioning = fullscreen
    ? "fixed inset-0 z-[9999] bg-white/85 backdrop-blur-sm"
    : "absolute inset-0";
  return (
    <div className={`${positioning} flex items-center justify-center`}>
      <div className="flex flex-col items-center gap-4">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-[#feae2c] border-t-transparent" />
        <p className="font-medium text-slate-600 animate-pulse">{t('appLoading')}</p>
      </div>
    </div>
  );
}
